import React from 'react';
import Services from '../Home/Services/Services';

const About = () => {
    return (
        <div>
            <Services></Services>

        </div>
    );
};

export default About;